import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "menu", "trigger" ]

  toggle(event) {
    event.preventDefault()
    this.menuTarget.classList.toggle("hidden")
    this._updateAria()
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this._updateAria()
  }

  closeOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  _updateAria() {
    const expanded = !this.menuTarget.classList.contains("hidden")
    this.triggerTarget.setAttribute("aria-expanded", expanded.toString())
  }
}
